import React from 'react';

export const CaliforniaInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of California</p>
        <p className="eds-l-mar-bot-1">
            <strong>California Small Business Loan Guarantee Program</strong>{' '}
            |&nbsp;
            <a
                href="https://ibank.ca.gov/small-business-finance-center/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The Small Business Finance Center (SBFC) partners with Financial
            Development Corporations to provide loan guarantees and direct loans
            for small businesses that experience capital access barriers.
        </p>

        <p className="eds-l-mar-bot-1 eds-l-mar-top-4">
            <strong>Jump Start Loan Program</strong> |&nbsp;
            <a
                href="https://ibank.ca.gov/small-business-finance-center/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The Jump Start Loan Program helps small businesses start, grow, and
            thrive. Jump Start provides microloans, technical assistance and
            financial literacy training.
        </p>

        <p className="eds-text-bl eds-l-mar-top-8 eds-l-mar-bot-4">
            City of Los Angeles
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Emergency Microloans</strong> |&nbsp;
            <a
                href="https://docs.google.com/spreadsheets/d/1i9j-E83Mft3FDKxOHzOsJX1hFdGtI7II0iNgjkzit2w/edit#gid=0&range=H25"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Los Angeles Mayor Eric Garcetti has announced an emergency loan
            program through an $11 million loan fund expected to serve 550 to
            2,500 businesses.
        </p>

        <p className="eds-text-bl eds-l-mar-top-8 eds-l-mar-bot-4">
            City of Sacramento
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Zero Interest Loans</strong> |&nbsp;
            <a
                href="https://cityofsac.forms.fm/covid19-relief/forms/7750"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The City of Sacramento is offering $1 million economic relief fund
            for businesses with zero-percent interest loans of up to $25,000 per
            business. Submissions open on March 19, 8am.
        </p>

        <p className="eds-text-bl eds-l-mar-top-8 eds-l-mar-bot-4">
            City of San Francisco
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business Relief Program</strong> |&nbsp;
            <a
                href="https://oewd.org/covid-19-small-business-resiliency-fund"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The Small Business Relief Program (initial investment of $1 million)
            will provide emergency grants of up to $10,000 for microbusinesses
            that can prove recent loss in revenue.
        </p>

        <p className="eds-text-bl eds-l-mar-top-8 eds-l-mar-bot-4">
            City of San Francisco
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Arts Relief Program</strong> |&nbsp;
            <a
                href="https://sfmayor.org/article/mayor-london-breed-announces-arts-relief-program"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                More Info
            </a>
        </p>
        <p>
            The SF Arts Relief Program is a $2.5 million program that will go to
            working artists and arts and cultural organizations financially
            impacted by COVID-19. The program will consist of two options, a
            grants program and low-interest loans, that will allow artists and
            organizations to choose what best meets their needs. The
            philanthropic community will be allowed to donate to these programs
            to expand impact.
        </p>

        <p className="eds-text-bl eds-l-mar-top-8 eds-l-mar-bot-4">
            San Francisco / Bay Area Queer Nightlife Fund
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Support Nightlife Workers</strong> |&nbsp;
            <a
                href="https://sfqueernightlifefund.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply / Donate
            </a>
        </p>
        <p>
            A collective of nightlife organizers, producers, entertainers, venue
            owners, and nonprofit community leaders is providing direct gifts of
            aid to workers from LGBTQ nightlife groups in the SF Bay Area. The
            SF QNF organizers have set a goal to raise $200,000 to fund 200
            grants to low- and moderate-income workers laid off from nightlife
            because of COVID-19.
        </p>
    </div>
);
